module.exports = __webpack_public_path__ + "static/media/info-grey.d87bb47b.svg";